import { createI18n } from 'vue-i18n';

import { messages } from './messages';

const locale = localStorage.getItem('translation') || 'ru';

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'ru',
  messages
});

export default i18n;
